module.exports = __webpack_public_path__ + "media/images/bg-oaw-2c777d8753bf30334c01f2106b56fe5e.svg";